import React from 'react'
import { TablePeriodFilterProps } from './TablePeriodFilter.types'
import styles from './TablePeriodFilter.module.scss'
import cl from 'classnames'
import { PeriodPicker } from 'components/common'

const TablePeriodFilterComponent = (props: TablePeriodFilterProps) => {
  const {
    className,
    ...rest
  } = props

  return (
    <PeriodPicker
      dateFormat='DD.MM.YY'
      noIcon
      label=''
      size='mini'
      placeholder='From-To'
      className={cl(styles.customFilterComponent, className)}
      {...rest}
    />
  )
}

const TablePeriodFilter = TablePeriodFilterComponent
export { TablePeriodFilter }
